<form [formGroup]="documentTypeForm" (ngSubmit)="onSubmit()" [hasUnsavedData]="documentTypeForm">
  <button type="submit" hidden="hidden"></button>

  <div class="row mb-2">
    <div class="col-12 mr-auto">

      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label
              class="form-title-label"
              for="name"
              translate
            >DOCUMENT_TYPE_LBL_NAME</label
            >
            <input
              id="name"
              class="form-control form-title"
              type="text"
              formControlName="name"
              [placeholder]="''"
              checkFormFieldValidity
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md">
      <div class="form-group row">
        <label class="col-4 col-form-label-sm" for="description" translate
        >DOCUMENT_TYPE_LBL_DESCRIPTION</label
        >
        <div class="col">
          <input
            id="description"
            class="form-control form-control-sm"
            type="text"
            formControlName="description"
            [placeholder]="''"
            checkFormFieldValidity
          />
        </div>
      </div>
    </div>
    <div class="col">  </div>
  </div>
</form>
